import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import type { Aufenthalt } from '@chancenwerk/db/enums/enums.js';
import { ChancenwerkUser } from '@chancenwerk/master-data-management/users/entities/ChancenwerkUser.js';
import { DateTime } from 'luxon';
import { DurchfuehrungsTag, Product } from './Product.js';

/**
 * @entity ProductLKK
 */
@Entity()
export class ProductLKK extends Product {
  public static override _class = 'ProductLKK';

  /**
   * If true the new LKK V2 courses are used.
   */
  @Field(type => Boolean)
  public useV2Courses: Maybe<boolean>;

  /**
   * Defines after which date the old LKK V1 courses are archived.
   * This means that up until this date the old data can still be accessed.
   */
  @Field(type => DateTime)
  public archiveV1After: Maybe<DateTime>;

  @Field(type => String)
  public lernkaskadeAufenthalt: Maybe<Aufenthalt>;

  @Field(type => String)
  public lernfoerderungAufenthalt: Maybe<Aufenthalt>;

  @Field(type => [DurchfuehrungsTag], { default: v => v ?? [] })
  public durchfuehrungsTage!: DurchfuehrungsTag[];

  @Field(type => Int)
  public ikProWoche: Maybe<number>;

  @Field(type => Int)
  public ikDauer: Maybe<number>;

  @Field(type => Int)
  public leFoeProWoche: Maybe<number>;

  @Field(type => Int)
  public leFoeDauer: Maybe<number>;

  @Field(type => Int)
  public uebungsLeiterProIK: Maybe<number>;

  @Field(type => Int)
  public OSProIK: Maybe<number>;

  @Field(type => Int)
  public uebungsLeiterProLernFoerderung: Maybe<number>;

  @Field(type => Int)
  public OSLernFoerderung: Maybe<number>;

  @Field(type => Int)
  public USLernFoerderung: Maybe<number>;

  initDefault() {
    this.leFoeProWoche = 2;
    this.leFoeDauer = 90;
    this.uebungsLeiterProLernFoerderung = 1;
    this.OSLernFoerderung = 6;
    this.USLernFoerderung = 12;
    this.ikProWoche = 1;
    this.ikDauer = 90;
    this.uebungsLeiterProIK = 1;
    this.OSProIK = 6;
  }
}
